import script from "./StepsBar.vue?vue&type=script&setup=true&lang=js"
export * from "./StepsBar.vue?vue&type=script&setup=true&lang=js"

import "./StepsBar.vue?vue&type=style&index=0&id=0b6c6e02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b6c6e02"]])

export default __exports__